import { Icon, IconName } from "Components/UI";
import Button from "Components/UI/Button";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import imgModels from "../../../../Static/images/empty-models.png";
import imgOthers from "../../../../Static/images/empty-models-other.png";
import styles from "./EmptyModels.module.scss";
import { IDrawerOptions } from "Pages/FederatedViewer/useFederatedViewer";

interface IEmptyModels {
  onPlay: () => void;
  isModelActive?: boolean;
  activeDrawer?: IDrawerOptions;
  hasUrns?: boolean;
}

const EmptyModels: FC<IEmptyModels> = ({
  onPlay,
  isModelActive,
  activeDrawer,
  hasUrns,
}) => {
  const { t } = useTranslation('federatedViewer');

  const getIcon = (): IconName => {
    if (activeDrawer === 'pranchas') {
      return 'filePile';
    }
    if (activeDrawer === 'viewpoints') {
      return 'viewPoint';
    }
    if (activeDrawer === 'views') {
      return 'docEye';
    }
    return 'menuHome';
  };

  return (
    <div
      className={styles['wrapper']}
    >
      {!isModelActive && (
        <div className={styles['headerWrapper']}>
          <Icon
            icon={getIcon()}
            customColor={'#BEC2C6'}
            customSize={16}
          />
          <span>
            {activeDrawer}
          </span>
        </div>
      )}
      <div className={styles['mainWrapper']}>
        <img src={isModelActive ? imgModels : imgOthers} alt="" />
        <p className={styles['title']}>
          {hasUrns
            ? t('emptyModels.noneAvailable', { drawer: activeDrawer })
            : isModelActive
              ? t('emptyModels.noModelAvailable')
              : t('emptyModels.noModelActive')}
        </p>
        <p className={styles['text']}>
          {hasUrns
            ? t('emptyModels.checkActiveModels', { drawer: activeDrawer })
            : isModelActive
              ? t('emptyModels.noModelUploaded')
              : t('emptyModels.activateModelFirst', { drawer: activeDrawer })
        }
        </p>
        <Button
          type="text"
          onClick={onPlay}
          className={styles['buttonVideo']}
        >
          <Icon
            icon={isModelActive ? 'camera' : 'ccube'}
            customColor={'#324150'}
            customSize={14}
          />
          <span>
            {isModelActive ? t('emptyModels.watchTutorial') : t('emptyModels.seeModels')}
          </span>
        </Button>
      </div>
    </div>
  )
}

export default EmptyModels;
